<template>
  <div class="product-info-overlay">
    <div class="product-info-overlay__accordion">
      <!-- Description Button -->
      <btn
        class="product-info-overlay__accordion-item"
        modifiers="text"
        :label="$string('product.accordion.description_title')"
        show-icon
        size="medium"
        @click="openOverlay('descriptionPopup')"
      >
        <template #icon>
          <icon-plus />
        </template>
      </btn>

      <!-- Nutrients & Vitamins Button -->
      <btn
        v-if="hasLiquidNutrition || hasNutrientsOrVitamins()"
        class="product-info-overlay__accordion-item"
        modifiers="text"
        :label="getNutritionHeadline()"
        show-icon
        size="medium"
        @click="openOverlay('nutrientsPopup')"
      >
        <template #icon>
          <icon-plus />
        </template>
      </btn>
    </div>

    <!-- Description Overlay -->
    <overlay
      direction="up-left"
      block-class="product-info-overlay__description"
      type="shelf-drawer"
      namespace="descriptionPopup"
      shelf-close
    >
      <template #title>
        <p
          class="title-mobile-m-bold"
          v-text="$string('product.accordion.description_title')"
        />
      </template>
      <template #body>
        <div class="product-info-overlay__content" js-body-scroll-lock-ignore>
          <!-- Goal Chips -->
          <div
            v-if="productData.goalChips.length > 0"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"
              v-text="$string('product.accordion.goals_title')"
            />
            <ul class="product-info-overlay__goal-chips">
              <li
                v-for="(chip, index) of productData.goalChips"
                :key="index"
                class="product-info-overlay__goal-chips--badge text-mobile-paragraph-s-bold text-desktop-paragraph-s-bold"
              >
                {{ chip }}
              </li>
            </ul>
          </div>

          <!-- Product Description -->
          <div class="product-info-overlay__section description-list">
            <div
              class="text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-html="productData.description"
            ></div>
          </div>

          <!-- Designation of Food -->
          <div
            v-if="getDesignationOfFood()"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"
              v-text="$string('product.accordion.designation_of_food')"
            />
            <p
              class="text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-html="getDesignationOfFood()"
            />
          </div>

          <!-- Ingredients -->
          <div
            v-if="currentVariant.ingredients"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"
              v-text="$string('product.accordion.ingredients')"
            />
            <div
              class="text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-html="currentVariant.ingredients"
            ></div>
          </div>

          <!-- Sizes -->
          <div v-if="getSizesLabels()" class="product-info-overlay__section">
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"
              v-text="$string('product.accordion.sizes')"
            />
            <p
              class="text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-html="getSizesLabels()"
            />
          </div>

          <!-- Consumption Recommendation -->
          <div
            v-if="productData.consumptionRecommendation"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"
              v-text="$string('product.accordion.consumption_recommendation')"
            />
            <div
              class="text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-html="productData.consumptionRecommendation"
            ></div>
          </div>

          <!-- Hint / Tip -->
          <div v-if="productData.hint" class="product-info-overlay__section">
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"
              v-text="$string('product.accordion.hint')"
            />
            <div
              class="text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-html="productData.hint"
            ></div>
          </div>
        </div>
      </template>
    </overlay>

    <!-- Nutrition & Vitamin Overlay -->
    <overlay
      direction="up-left"
      block-class="product-info-overlay__nutrition"
      type="shelf-drawer"
      namespace="nutrientsPopup"
      shelf-close
    >
      <template #title>
        <p class="title-mobile-m-bold" v-text="getNutritionHeadline()" />
      </template>
      <template #body>
        <div class="product-info-overlay__content" js-body-scroll-lock-ignore>
          <!-- Nutrition Values -->
          <div
            v-if="currentVariant.nutritionValues"
            class="product-info-overlay__section product-info-overlay__nutrition-section"
          >
            <h3
              v-if="
                currentVariant.vitaminValues ||
                currentVariant.mineralValues ||
                currentVariant.aminoAcidValues
              "
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-m-bold"
              v-text="$string('product.accordion.nutritional_values')"
            />
            <div ref="nutritionTable" class="accordion-snippet__table" />
          </div>

          <!-- Vitamin Values -->
          <div
            v-if="currentVariant.vitaminValues"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-m-bold"
              v-text="$string('product.accordion.vitamin_values')"
            />
            <div ref="vitaminTable" class="accordion-snippet__table" />
          </div>

          <!-- Mineral Values -->
          <div
            v-if="currentVariant.mineralValues"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-m-bold"
              v-text="$string('product.accordion.mineral_values')"
            />
            <div ref="mineralTable" class="accordion-snippet__table" />
          </div>

          <!-- Amino Acid Values -->
          <div
            v-if="currentVariant.aminoAcidValues"
            class="product-info-overlay__section"
          >
            <h3
              class="text-mobile-paragraph-m-bold text-desktop-paragraph-m-bold"
              v-text="$string('product.accordion.amino_acid_profile')"
            />
            <div ref="aminoAcidTable" class="accordion-snippet__table" />
          </div>
        </div>
      </template>
    </overlay>
  </div>
</template>

<script>
/**
 * Vue: Product info overlay (product-info-overlay)
 * -----------------------------------------------------------------------------
 * Product Information in a shelf overlay, underneath product form.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */

import { mapActions } from 'pinia';
import Overlay from '~global/overlay/overlay.vue';
import IconPlus from '~icons/directional-navigation/plus.svg';
import Btn from '~global/btn/btn.vue';

import { convertToHandle } from '~/helpers/convert';
import { decodeApiId } from '~/helpers/graphql';
import { isPreviewMode } from '~/helpers/vue';

import { convertJsontoTable } from '~/helpers/product-information';

import useOverlaysStore from '~stores/overlays';
import productMetafieldsQuery from '~graphql/product-metafields.gql';

export default {
  name: 'ProductInfoOverlay',
  components: {
    Btn,
    IconPlus,
    Overlay,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
    variant: {
      type: [Boolean, Object],
      default: null,
    },
    hasLiquidNutrition: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      productData: {
        description: '',
        applicationPage: null,
        consumptionRecommendation: '',
        goalChips: [],
        hint: '',
        designationOfFood: '',
      },
      variantsCache: {},
      currentVariant: {
        designationOfFood: '',
        ingredients: '',
        nutritionValues: null,
        vitaminValues: null,
        mineralValues: null,
        aminoAcidValues: null,
        selectedOptions: [],
      },
      isLoading: false,
      isCacheReady: false,
    };
  },

  computed: {
    /**
     * Get current variant ID as numeric ID
     * Extracts numeric ID from GraphQL ID format or uses ID directly
     */
    currentVariantId() {
      const variantId =
        this.variant?.id || this.product?.selectedOrFirstAvailableVariant?.id;

      if (!variantId) return null;

      // If it's a GraphQL ID (gid://shopify/ProductVariant/123456), extract the numeric part
      if (typeof variantId === 'string' && variantId.includes('gid://')) {
        return decodeApiId(variantId);
      }

      // Otherwise return as-is (already numeric)
      return String(variantId);
    },
  },

  watch: {
    currentVariantId(newVariantId) {
      if (newVariantId) {
        this.updateCurrentVariant(newVariantId);
      }
    },
  },

  async mounted() {
    await this.fetchProductMetafields();

    // Use event delegation for dropdown changes
    this.$el.addEventListener('change', this.handleDropdownChange);
  },

  beforeUnmount() {
    this.$el.removeEventListener('change', this.handleDropdownChange);
  },

  methods: {
    /**
     * Map Pinia actions.
     */
    ...mapActions(useOverlaysStore, {
      openOverlayAction: 'open',
    }),

    /**
     * Fetch all product and variant metafields in one request
     * Caches all variants for instant switching without additional API calls
     * In preview mode, uses liquid data instead of GraphQL
     */
    async fetchProductMetafields() {
      this.isLoading = true;

      // Check if in preview mode
      const inPreviewMode = isPreviewMode(this.$variable('page.design_mode'));

      // In preview mode, use liquid product data
      if (
        inPreviewMode &&
        this.product.liquid &&
        this.product.variants?.length > 0
      ) {
        try {
          this.storeProductDataFromLiquid(this.product);
          this.cacheAllVariantsFromLiquid(this.product.variants);
          this.setInitialVariant();
        } finally {
          this.isLoading = false;
        }
        return;
      }

      try {
        const response = await cnvs.Query({
          query: productMetafieldsQuery,
          variables: {
            country: this.$variable('store.country'),
            handle: this.product.handle,
            language: this.$variable('store.language'),
          },
        });

        const product = response.product;

        if (!product) {
          // Try to use liquid data as fallback
          if (this.product.liquid && this.product.variants?.length > 0) {
            this.storeProductDataFromLiquid(this.product);
            this.cacheAllVariantsFromLiquid(this.product.variants);
            this.setInitialVariant();
          }
          return;
        }

        this.storeProductData(product);
        this.cacheAllVariants(product.variants?.nodes);
        this.setInitialVariant();
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Store product-level metafields from liquid data
     * Only uses basic properties available in liquid - metafields need to be explicitly rendered
     */
    storeProductDataFromLiquid(product) {
      this.productData = {
        description: product.description || '',
        // Metafields are only available if explicitly rendered in liquid
        applicationPage: product.applicationPage || null,
        consumptionRecommendation: product.consumptionRecommendation || '',
        goalChips: Array.isArray(product.goalChips) ? product.goalChips : [],
        hint: product.hint || '',
        designationOfFood: product.designationOfFood || '',
      };
    },

    /**
     * Cache all variants from liquid data
     * Only uses basic variant properties - metafields need to be explicitly rendered
     */
    cacheAllVariantsFromLiquid(variants) {
      if (!variants || !Array.isArray(variants)) {
        return;
      }

      variants.forEach((variant) => {
        const variantId = String(variant.id);
        this.variantsCache[variantId] = {
          id: variantId,
          title: variant.title || '',
          availableForSale: variant.available !== false,
          selectedOptions: variant.selectedOptions || [],
          // Metafields are only available if explicitly rendered in liquid
          ingredients: variant.ingredients || null,
          designationOfFood: variant.designationOfFood || null,
          nutritionValues: variant.nutritionValues || null,
          aminoAcidValues: variant.aminoAcidValues || null,
          mineralValues: variant.mineralValues || null,
          vitaminValues: variant.vitaminValues || null,
        };
      });
    },

    /**
     * Store product-level metafields
     */
    storeProductData(product) {
      this.productData = {
        description: product.description || '',
        applicationPage: product.applicationPage?.reference || null,
        consumptionRecommendation:
          product.consumptionRecommendation?.[0]?.value || '',
        goalChips: JSON.parse(product.goalChips?.[0]?.value || '[]'),
        hint: product.hint?.[0]?.value || '',
        designationOfFood: product.designationOfFood?.[0]?.value || '',
      };
    },

    /**
     * Cache all variants for instant switching
     */
    cacheAllVariants(variants) {
      if (!variants) return;

      for (const variant of variants) {
        const numericId = variant.id.split('/').pop();

        this.variantsCache[numericId] = {
          id: numericId,
          title: variant.title,
          availableForSale: variant.availableForSale,
          selectedOptions: variant.selectedOptions || [],
          designationOfFood: variant.designationOfFood?.[0]?.value || '',
          ingredients: variant.ingredients?.[0]?.value || '',
          nutritionValues: variant.nutritionValues?.[0]?.value || null,
          vitaminValues: variant.vitaminValues?.[0]?.value || null,
          mineralValues: variant.mineralValues?.[0]?.value || null,
          aminoAcidValues: variant.aminoAcidValues?.[0]?.value || null,
        };
      }
    },

    /**
     * Set initial variant after caching
     */
    setInitialVariant() {
      this.isCacheReady = true;

      if (this.currentVariantId) {
        this.updateCurrentVariant(this.currentVariantId);
      }
    },

    async updateCurrentVariant(variantId) {
      // The watcher can fire before the cache is filled; setInitialVariant catches up.
      if (!variantId || !this.isCacheReady) {
        return;
      }

      const cachedVariant = this.variantsCache[variantId];

      if (cachedVariant) {
        this.currentVariant = cachedVariant;

        // Update tables in next tick after DOM is updated
        await this.$nextTick();
        this.updateTables();
      } else {
        cnvs.ReportError(
          new Error(`Variant with ID ${variantId} not found in cache.`),
          {
            context: 'ProductInfoOverlay.updateCurrentVariant',
          },
        );
      }
    },

    /**
     * Update a single table with data from helper function
     */
    updateTable(refName, data) {
      const tableRef = this.$refs[refName];
      if (!tableRef || !data) return;

      tableRef.innerHTML = '';
      const table = convertJsontoTable(data);
      if (table) {
        tableRef.appendChild(table);
      }
    },

    /**
     * Update all table DOM elements with data from helper function
     */
    updateTables() {
      this.updateTable('nutritionTable', this.currentVariant.nutritionValues);
      this.updateTable('vitaminTable', this.currentVariant.vitaminValues);
      this.updateTable('mineralTable', this.currentVariant.mineralValues);
      this.updateTable('aminoAcidTable', this.currentVariant.aminoAcidValues);
    },

    /**
     * Handle dropdown change for table column visibility
     */
    handleDropdownChange(event) {
      const dropdown = event.target;
      if (!dropdown.classList.contains('product-information__dropdown')) {
        return;
      }

      const container = dropdown.closest('.accordion-snippet__table');
      if (!container) {
        return;
      }

      const selectedColumn = convertToHandle(dropdown.value);
      const table = container.querySelector('.data-table');
      if (!table) {
        return;
      }

      const allCells = table.querySelectorAll('td, th');
      for (const cell of allCells) {
        const cellColumn = cell.dataset.column;
        cell.style.display =
          cellColumn === selectedColumn || cellColumn === 'value' ? '' : 'none';
      }
    },

    openOverlay(namespace) {
      this.openOverlayAction({
        ignoreDismissed: true,
        namespace,
      });
    },

    hasNutrientsOrVitamins() {
      return Boolean(
        this.currentVariant.nutritionValues ||
        this.currentVariant.vitaminValues ||
        this.currentVariant.mineralValues ||
        this.currentVariant.aminoAcidValues,
      );
    },

    /**
     * Get designation of food - prioritize variant over product
     */
    getDesignationOfFood() {
      return (
        this.currentVariant.designationOfFood ||
        this.productData.designationOfFood
      );
    },

    /**
     * Get sizes labels
     * @returns {String|null}
     */
    getSizesLabels() {
      if (!this.product || !this.currentVariant) {
        return null;
      }

      const sizesOption = this.product.options?.find((option) => {
        return this.$variable('product.sizeOptions').includes(
          option.name.toLowerCase(),
        );
      });

      if (!sizesOption) {
        return null;
      }

      // Use variantsCache instead of product.variants
      const allVariants = Object.values(this.variantsCache);

      if (
        !this.currentVariant.selectedOptions ||
        this.currentVariant.selectedOptions.length === 0
      ) {
        return null;
      }

      const availableProductVariants = allVariants.filter(
        (variant) =>
          variant.selectedOptions?.[0]?.value ===
            this.currentVariant.selectedOptions?.[0]?.value &&
          variant.availableForSale !== false,
      );

      if (!availableProductVariants || availableProductVariants.length === 0) {
        return null;
      }

      const labels = availableProductVariants.map((item) => {
        if (item.selectedOptions.length > 1) {
          return item.selectedOptions[1].value;
        }
        return item.selectedOptions[0].value;
      });

      return labels.join(' / ');
    },

    /**
     * Get nutrition headline - includes combination of available nutrition data
     */
    getNutritionHeadline() {
      const hasVitamins = Boolean(this.currentVariant.vitaminValues);
      const hasMinerals = Boolean(this.currentVariant.mineralValues);
      const hasAminoAcids = Boolean(this.currentVariant.aminoAcidValues);

      if (hasAminoAcids && !hasVitamins && !hasMinerals) {
        return this.$string(
          'product.accordion.nutritional_values_and_amino_acid_profile',
        );
      }

      if (hasMinerals && !hasVitamins && !hasAminoAcids) {
        return this.$string(
          'product.accordion.nutritional_values_and_minerals',
        );
      }

      if (hasVitamins && !hasMinerals && !hasAminoAcids) {
        return this.$string(
          'product.accordion.nutritional_values_and_vitamins',
        );
      }

      return this.$string('product.accordion.nutritional_values');
    },
  },
};
</script>

<style lang="scss">
@import './product-info-overlay';
</style>
